import { render, staticRenderFns } from "./noAvailable.vue?vue&type=template&id=bb0931d4&scoped=true"
import script from "./noAvailable.vue?vue&type=script&lang=js"
export * from "./noAvailable.vue?vue&type=script&lang=js"
import style0 from "./noAvailable.vue?vue&type=style&index=0&id=bb0931d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0931d4",
  null
  
)

export default component.exports